import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('rate_factor_sets',
  '/rate_factor_sets',
  'rate_factor_set')
const reducer = generator.generate()

export default reducer
